import { render } from "./Streaming.vue?vue&type=template&id=63f78e66&scoped=true"
import script from "./Streaming.vue?vue&type=script&lang=js"
export * from "./Streaming.vue?vue&type=script&lang=js"

import "./Streaming.vue?vue&type=style&index=0&id=63f78e66&scoped=true&lang=css"

import exportComponent from "/Users/xueke/Develop/Work/rococo/weshow-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f78e66"]])

export default __exports__